module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLHeader'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "submenu clearfix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', [_c('li', {
    class: {
      active: this.searchtype == 'simple'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changeSearchType('simple')
      }
    }
  }, [_vm._v("Egyszerű kereső")])]), _vm._v(" "), _c('li', {
    class: {
      active: this.searchtype == 'advanced'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changeSearchType('advanced')
      }
    }
  }, [_vm._v("Bővített kereső")])])])])]), _vm._v(" "), (_vm.searchtype == 'simple') ? _c('section', {
    staticClass: "container",
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('EgyszeruKereso', {
    attrs: {
      "searchItems": _vm.searchItems,
      "searchOptions": _vm.searchOptions,
      "changeSearchOption": _vm.changeSearchOption,
      "clickSearch": _vm.clickSearch
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.searchtype == 'advanced') ? _c('section', {
    staticClass: "container",
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('BovitettKereso', {
    attrs: {
      "searchItems": _vm.searchItems,
      "searchOptions": _vm.searchOptions,
      "changeSearchOption": _vm.changeSearchOption,
      "clickSearch": _vm.clickSearch,
      "selected_searchOptions": _vm.selected_searchOptions,
      "comboAdd": _vm.comboAdd,
      "comboRemove": _vm.comboRemove
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "searchResults"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.items.length > 0) ? _c('div', {
    staticClass: "search-result-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          Találatok\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "amount"
  }, [_vm._v("\n          Összesen "), _c('span', [_vm._v(_vm._s(_vm.items.length))]), _vm._v(" találat "), _c('span', [_vm._v("1")]), _vm._v(" oldalon.\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.items.length > 0) ? _c('select', {
    staticClass: "form-control auto-width",
    attrs: {
      "name": "teszt"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Értékelés szerint növekvő")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Értékelés szerint csökkenő")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Név szerint növekvő")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Név szerint csökkenő")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Megtekintés szerint növekvő")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Megtekintés szerint csökkenő")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search-result-items"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.items), function(item, i) {
    return _c('div', {
      staticClass: "col-sm-6 col-md-4"
    }, [_c('div', {
      staticClass: "search-result-item"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "photo",
      style: ({
        'background-image': 'url(\'assets/img/' + item.photo + '\')'
      })
    }, [_vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "user-type student"
    }, [_vm._v("\n                  " + _vm._s(item.type) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "evaluation-wrapper"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n                    Értékelése\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "bar-wrapper"
    }, [_c('div', {
      staticClass: "bar-bg"
    }, [_c('div', {
      staticClass: "bar",
      style: ({
        'background-color': item.bar_color,
        width: item.evaulation + '%'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v("\n                      " + _vm._s(item.evaulation) + "%\n                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "metadata"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v("\n                      " + _vm._s(item.publications.amount) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_vm._v("\n                      Publikáció\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v("\n                      " + _vm._s(item.watched) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_vm._v("\n                      Megtekintés\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v("\n                      " + _vm._s(item.languages.amount) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_vm._v("\n                      Nyelvismeret\n                    ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "more"
    }, [_c('router-link', {
      staticClass: "button v2",
      attrs: {
        "to": {
          path: '/userpage',
          query: {
            id: item.id
          }
        }
      }
    }, [_vm._v("Bővebben")])], 1)])])
  }))]), _vm._v(" "), (_vm.items.length > 0) ? _c('div', {
    staticClass: "breadcrumbs clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "result"
  }, [_vm._v("\n          Összesen "), _c('span', [_vm._v(_vm._s(_vm.items.length))]), _vm._v(" találat "), _c('span', [_vm._v("1")]), _vm._v(" oldalon.\n        ")])]) : _vm._e()])]), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProfileMenu')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage-head-image",
    staticStyle: {
      "background-image": "url('assets/img/subpage-head.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n        Keresés\n        "), _c('span', [_vm._v("Keressen a rendszerben lévő tagok között")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon student"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "prev"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/img/arrow.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "active",
    attrs: {
      "href": ""
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', {
    staticClass: "next"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/img/arrow.png",
      "alt": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7941e3fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/search.vue
// module id = 388
// module chunks = 0